import { Container, Paper, SxProps, Theme } from '@mui/material';
import { PropsWithChildren } from 'react';
import { Header } from 'shared/header';

const containerStyles: SxProps<Theme> = (theme: Theme) => ({
  marginTop: theme.spacing(2),
});

export function AuthLayout({ children }: PropsWithChildren<{}>) {
  return (
    <div>
      <Header />
      <Container sx={containerStyles} maxWidth={false}>
        <Paper>{children}</Paper>
      </Container>
    </div>
  );
}
